<template>
  <rabbey-base-drawer
    title="Detalle de Cuentas"
    :drawer.sync="drawer"
    size="65%"
    @close="handleClose"
    @open="onOpen"
  >
    <h3>{{ row.Concept }}</h3>

    <el-row>
      <el-col>
        <rabbey-table-3
          ref="table"
          :loading="loading"
          :actions="actions"
          :columns="columns"
          :data="items"
          :paginate-fromApi="false"
          @rtable-push-action="actionHandler"
        />
      </el-col>
    </el-row>

    <ChangePostingDateAndAmount
      ref="changePostingDate"
      @success="onChangePDSuccess"
      @error="refresh"
    />
  </rabbey-base-drawer>
</template>

<script>
import { formatDate } from "@/utils";
import CheckedForColumnsVue from "@/components/functionals/checkedForColumns.vue";
import RenderCheck from "@/components/functionals/RenderCheck.vue";
import ChangePostingDateAndAmount from "./ChangePostingDateAndAmount.vue";

export default {
  name: "ViewAccounts",
  events: ["refresh"],
  components: { ChangePostingDateAndAmount },
  props: {
    month: {
      type: Number,
      default: null
    },
    year: {
      type: Number,
      default: null
    },
    typePronostico: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      drawer: false,
      loading: true,
      items: [],
      actions: [
        {
          icon: "el-icon-date",
          label: "Editar pago",
          command: "change-date-payment",
          condition: (row) => row.AccountNumber != "XXXX"
        },
        {
          icon: "el-icon-edit-outline",
          label: "Editar nombre de cuenta",
          command: "edit-account",
          condition: (row) => row.AccountNumber != "XXXX"
        },
        {
          icon: "el-icon-finished",
          label: "Ejecutar",
          command: "execute",
          condition: (row) => row.AccountNumber != "XXXX"
        },
        {
          label: "Proyectar",
          command: "to-project",
          icon: "el-icon-video-camera",
          condition: (row) => row.AccountNumber != "XXXX"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete",
          condition: (row) => row.AccountNumber != "XXXX"
        }
      ],
      columns: [
        {
          prop: "Id",
          label: "NO.",
          width: 90,
          sortable: true
        },
        {
          prop: "AccountNumber",
          label: "No. Cuenta",
          minWidth: 150,
          sortable: true
        },
        {
          prop: "AccountName",
          label: "Nombre",
          minWidth: 200,
          sortable: true
        },
        {
          prop: "commentary",
          label: "Detalles",
          minWidth: 200,
          sortable: true
        },
        {
          prop: "Amount",
          label: "Monto proyectado",
          minWidth: 200,
          sortable: true,
          formatter: ({ Amount }) => {
            var formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD"
            });

            return formatter.format(Amount);
          }
        },
        {
          prop: "LookingForward",
          label: "Proyecta",
          minWidth: 120,
          sortable: true,
          formatter: CheckedForColumnsVue
        },
        {
          prop: "Executed",
          label: "Ejecutado",
          minWidth: 120,
          sortable: true,
          formatter: RenderCheck
        },
        {
          prop: "PostingDate",
          label: "Ultimo monto ejecutado",
          minWidth: 205,
          sortable: true,
          formatter: (row) => formatDate(row.PostingDate, "DD/MM/YYYY")
        }
      ],
      row: {
        Id: 0,
        Concept: "",
        Type: 0
      }
    };
  },
  methods: {
    show(row, column) {
      column;
      //console.log("row on details: ",row , "\n columns on details: ", column);
      this.row = row;
      this.drawer = true;
    },
    onOpen() {
      this.getData();
    },
    handleClose() {
      this.loading = true;
      this.items = [];
      this.row = {
        Id: 0,
        Concept: "",
        Type: 0
      };
    },
    getData() {
      this.loading = true;
      this.$http
        .get("/api/CashFlow/GetCashFlowDetails", {
          params: {
            RowCashFlowId: this.row.Id,
            RowType: this.row.Type,
            month: this.month,
            year: this.year,
            TypePronostico: this.typePronostico,
            CompanyId: this.currentUser.CompanySelected
          }
        })
        .then(({ data }) => {
          this.items = data;
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          // this.month = "";s
        });
    },
    actionHandler({ command, row }) {
      const actions = {
        "change-date-payment": () => {
          this.$refs.changePostingDate.show(row);
        },
        execute: () => {
          this.toExecute(row.Id);
        },
        "to-project": () => {
          this.lookingForward(row);
        },
        delete: () => {
          this.deleteDetaislAccount(row.Id);
        },
        "edit-account": () => {
          //console.log ("popconfirm: ", this.$refs.popconfirm)
          //this.$refs.popconfirm.reference
          this.$prompt(
            "Por favor ingrese el nuevo nombre para la cuenta",
            "Tip",
            {
              confirmButtonText: "Cambiar",
              cancelButtonText: "Cancelar",
              inputPattern: /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
              inputErrorMessage: "Nombre invalido"
            }
          )
            .then(({ value }) => {
              //console.log("value: ",value, "\n row: ",row);
              this.$http
                .put("/api/CashFlow/EditCashFlowDetailName", {
                  Id: row.Id,
                  Type: row.Type,
                  AccountName: value
                })
                .then((resp) => {
                  resp;
                  this.getData();
                });
              this.$message({
                type: "success",
                message: "El numbro nombre para esta cuenta es: " + value
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Cambio de nombre de cuenta Cancelado"
              });
            });
        }
      };
      actions[command]();
      return;
    },
    refresh() {
      this.$emit("refresh");
      this.getData();
    },
    toExecute(id) {
      this.loading = true;
      this.$http
        .post("/api/CashFlow/Executed", {
          RowDetailID: id
        })
        .then(({ data }) => {
          if (data == true) {
            this.$notify.success({
              duration: 5000,
              message: "Cuenta ejecutada correctamente",
              title: "Información",
              position: "top-left"
            });

            this.$emit("refresh", this.row.Id);
            this.getData();
          }
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteDetaislAccount(val) {
      this.$confirm(
        `¿Está seguro/a de eliminar esta cuenta? ¡Esto es permanente y esta acción elimina la cuenta y todas sus proyecciones!`,
        "¡Cuidado!",
        {
          type: "warning",
          confirmButtonText: "Si",
          cancelButtonText: "No"
        }
      )
        .then((response) => {
          if (response === "confirm") {
            this.loading = true;
            this.$http
              .delete("/api/CashFlow/DeleteLineadeRenglon", {
                params: {
                  ID: val
                }
              })
              .then(({ data }) => {
                if (data == true) {
                  this.$notify.success({
                    duration: 5000,
                    message: "Registro de cuenta eliminado",
                    title: "Información",
                    position: "top-left"
                  });

                  this.$emit("refresh", this.row.Id);
                  this.getData();
                }
              })
              .catch((error) => {
                this.$message.error("Error al consultar los Registros");
                console.error(error);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        })
        .catch((response) => {
          if (response === "cancel") {
            this.$notify.success({
              duration: 5000,
              message: "Renglón no eliminado",
              title: "Información",
              position: "top-left"
            });
          }
        });
    },

    onChangePDSuccess() {
      this.$emit("refresh", this.row.Id);
      this.getData();
    },

    lookingForward({ CurrentRowId, Id, LookingForward }) {
      if (!LookingForward) {
        this._lookingForward(CurrentRowId, Id);
      } else {
        this.$confirm(
          "Esta acción eliminará las proyecciones. ¿Desea proceder?",
          "Confirmación",
          { type: "info", confirmButtonText: "Si", cancelButtonText: "No" }
        ).then((response) => {
          if (response === "confirm") {
            this._lookingForward(CurrentRowId, Id);
          }
        });
      }
    },

    _lookingForward(CurrentRowId, Id) {
      this.$http
        .post("/api/CashFlow/AccountingForward", {
          CashFlowID: CurrentRowId,
          AccountID: Id
        })
        .then((data) => {
          if (data) {
            this.$message.success("Proyeccion exita");
            this.$emit("refresh", CurrentRowId);
            this.getData();
          } else {
            this.$message.warning("Que paso ?");
          }
        })
        .catch((error) => {
          this.$message.warning("Proyección fallida");
          console.error(error);
        });
    }
  }
};
</script>
